import { createAsyncThunk } from "@reduxjs/toolkit";
import { RootState } from "../app/store";
import { fetchCaseInfo } from "./Case";
import { isCreditAreaOfFraud, isCyberAreaOfFraud, isOperationalAreaOfFraud, selectCaseHeader, selectCaseHeaderLoadingStatus } from "../features/caseinfo/logic/Slice";
import { fetchAdditionalAnalysis, fetchBorrowerVerifications, fetchInterviewsStep } from "./AnalysisStep";
import { fetchCaseDocuments } from "./caseDocument";
import { resetCaseNotes } from "../features/remarks/logic/CaseNotesSlice";
import { getObservationsThunk } from "../features/observations/logic/Thunk";
import { getRecommendationsThunk } from "../features/recommendations/logic/Thunk";
import { selectRecommendationStatus } from "../features/recommendations/logic/Slice";
import { selectObservationsStatus } from "../features/observations/logic/Slice";
import { getAccountProductInfo } from "../features/creditAccounts/logic/slice";

export const fetchAnalysisStepsData = createAsyncThunk<
    void,
    { caseId: string },
    {state: RootState, rejectValue: void}
>(
    "case/fetchAnalysisStepsData",
    async ({caseId}, {rejectWithValue, dispatch, getState}) => {
        try{
            const state: RootState = getState();
            const accountProductInfo = getAccountProductInfo(state);
            const lrIds = accountProductInfo.map(a => a.loan_reference_id);
            const lrIdsTrimmed = lrIds?.map(id => String(id).trim());

            const isCreditFraud = isCreditAreaOfFraud(state);
            const isOperationalFraud = isOperationalAreaOfFraud(state);
            const isCyberFraud = isCyberAreaOfFraud(state);

            // Todo remove from here and introduce into respective components
            if(isCreditFraud) {
                dispatch(fetchBorrowerVerifications({case_id: caseId, loan_reference_ids: lrIdsTrimmed}));
            }
            
            if(isCreditFraud || isOperationalFraud) {
                dispatch(fetchInterviewsStep({case_id: caseId}));
            }

            if(isOperationalFraud || isCyberFraud) {
                dispatch(fetchAdditionalAnalysis({case_id: caseId}));
            }
            
        } catch(error) {
            console.error(error);
            return rejectWithValue();
        }
    }
)

export const fetchFullCaseData = createAsyncThunk<
    void,
    { caseId: string,canAccessInvestigation: boolean },
    {state: RootState, rejectValue: void}
>(
    "case/fetchFullData",
    async ({caseId, canAccessInvestigation}, {rejectWithValue, dispatch, getState}) => {
        try{
            await dispatch(fetchCaseInfo({case_id: caseId}));
            
            const state: RootState = getState();
            const caseInfoLoadingStatus = selectCaseHeaderLoadingStatus(state)
            const caseData = selectCaseHeader(state);

            if(caseInfoLoadingStatus==='succeeded' && caseData !== null && canAccessInvestigation) {
                dispatch(resetCaseNotes());
                dispatch(fetchAnalysisStepsData({caseId}));
                dispatch(fetchCaseDocuments({ case_id: caseId }));

                const observationsStatus = selectObservationsStatus(state, caseId);
                if(observationsStatus !== 'loading')
                    dispatch(getObservationsThunk({ case_id: caseId }));

                const recommendationsStatus = selectRecommendationStatus(state, caseId);
                if(recommendationsStatus !== 'loading')
                    dispatch(getRecommendationsThunk({ case_id: caseId }));
            }
            
        } catch(error) {
            console.error(error);
            return rejectWithValue();
        }
    }
)